import { createContext, type ReactNode, useContext } from 'react'

export type Platform = 'sheets' | 'excel'

const PlatformContext = createContext<Platform>('excel')

export function PlatformProvider({
  children,
  platform,
}: {
  children: ReactNode
  platform: Platform
}) {
  return (
    <PlatformContext.Provider value={platform}>
      {children}
    </PlatformContext.Provider>
  )
}

export function usePlatform(): Platform {
  return useContext(PlatformContext)
}
